<div class="overflow-menu" (clickOutside)="closeMenu()">
  <button
    class="overflow-menu__button button button--small button--secondary"
    [class.active]="menuActive()"
    [class.button--disabled]="!enabled()"
    (click)="toggleMenu()"
  >
    <svg-icon src="assets/images/icons/cog.svg" class="button__icon" />
    <span>{{ "Global.Modify" | translate }}</span>
  </button>
  <div class="overflow-menu__items" (click)="closeMenu()">
    <ng-content />
  </div>
</div>
